import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import VehicleExpenseService from "services/VehicleExpenseService";
import moment from "moment";

export const getVehicleExpenseCategoriesApi = createAsyncThunk(
  "vehicleExpense/get-categories",
  async (data, { rejectWithValue }) => {
    try {
      const response = await VehicleExpenseService.getCategories();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createVehicleExpenseCategoryApi = createAsyncThunk(
  "vehicleExpense/create-category",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await VehicleExpenseService.createCategory(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateVehicleExpenseCategoryApi = createAsyncThunk(
  "vehicleExpense/update-category",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await VehicleExpenseService.updateCategory(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteVehicleExpenseCategoryApi = createAsyncThunk(
  "vehicleExpense/delete-category",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await VehicleExpenseService.deleteCategory(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllVehicleExpenseApi = createAsyncThunk(
  "vehicleExpense/get-all",
  async (data, { rejectWithValue }) => {
    try {
      const response = await VehicleExpenseService.getAll(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getVehicleExpenseSummaryApi = createAsyncThunk(
  "vehicleExpense/get-summary",
  async (data, { rejectWithValue }) => {
    try {
      const response = await VehicleExpenseService.getSummary(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getVehicleExpenseByIdApi = createAsyncThunk(
  "vehicleExpense/get-by-id",
  async (data, { rejectWithValue }) => {
    try {
      const response = await VehicleExpenseService.getById(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createVehicleExpenseApi = createAsyncThunk(
  "vehicleExpense/create",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await VehicleExpenseService.create(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateVehicleExpenseApi = createAsyncThunk(
  "vehicleExpense/update",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await VehicleExpenseService.update(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteVehicleExpenseApi = createAsyncThunk(
  "vehicleExpense/delete",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await VehicleExpenseService.delete(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const approveVehicleExpenseApi = createAsyncThunk(
  "vehicleExpense/approve",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await VehicleExpenseService.approve(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const payVehicleExpenseApi = createAsyncThunk(
  "vehicleExpense/pay",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await VehicleExpenseService.pay(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const exportExcelVehicleExpenseApi = createAsyncThunk(
  "vehicleExpense/export-excel-vehicle-expense",
  async (data, { rejectWithValue }) => {
    try {
      const blob = await VehicleExpenseService.exportExcel(data);
      const url = window.URL.createObjectURL(blob);

      const exportTime = moment().format("DDMMYYYY_HHmmss");
      const filename = `Danh_sach_chi_phi_xe_${exportTime}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  vehicleExpenseList: [],
  vehicleExpenseSummary: {},
  categoryList: [],
  vehicleExpenseDetail: {},
};

export const vehicleExpenseSlice = createSlice({
  name: "vehicleExpense",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleExpenseCategoriesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVehicleExpenseCategoriesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryList = action.payload;
      })
      .addCase(getVehicleExpenseCategoriesApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createVehicleExpenseCategoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createVehicleExpenseCategoryApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createVehicleExpenseCategoryApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateVehicleExpenseCategoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVehicleExpenseCategoryApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateVehicleExpenseCategoryApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteVehicleExpenseCategoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteVehicleExpenseCategoryApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteVehicleExpenseCategoryApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getAllVehicleExpenseApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllVehicleExpenseApi.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleExpenseList = action.payload;
      })
      .addCase(getAllVehicleExpenseApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getVehicleExpenseSummaryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVehicleExpenseSummaryApi.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleExpenseSummary = action.payload;
      })
      .addCase(getVehicleExpenseSummaryApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getVehicleExpenseByIdApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVehicleExpenseByIdApi.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleExpenseDetail = action.payload;
      })
      .addCase(getVehicleExpenseByIdApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createVehicleExpenseApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createVehicleExpenseApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createVehicleExpenseApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateVehicleExpenseApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVehicleExpenseApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateVehicleExpenseApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteVehicleExpenseApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteVehicleExpenseApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteVehicleExpenseApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(approveVehicleExpenseApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(approveVehicleExpenseApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(approveVehicleExpenseApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(payVehicleExpenseApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(payVehicleExpenseApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(payVehicleExpenseApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(exportExcelVehicleExpenseApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(exportExcelVehicleExpenseApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(exportExcelVehicleExpenseApi.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = vehicleExpenseSlice.actions;

export default vehicleExpenseSlice.reducer;
